import styled from 'styled-components';

export const TranslationStyled = styled.div`
  .banner-grant-permission {
    .Polaris-InlineStack {
      align-items: center;
    }
    .button-group {
      display: flex;
      gap: 8px;
      align-items: center;
      @media (min-width: 768px) {
        margin-right: 16px;
        .Polaris-Button {
          min-width: 124px;
          height: fit-content;
        }
      }
    }
  }
`;
